import config from 'config';

export const prefixAccount = () => {
  return config.usernamePrefix.ignoreChar;
};

export const allowOnlyNumbers = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/utils.ts